import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt, faSearch, faWrench, faEllipsisH, faShieldAlt } from '@fortawesome/free-solid-svg-icons'

import SearchLocationModal from '../../components/search-location-modal'
import { getTopServices } from '../../../utils/request'
import services from '../../../services/api'
import { handleChange, addFilters, clearFilters } from '../../../store/actions/provider'

// Autopecas e um ramo (branch) no cadastro, mas a tela de empresas filtra pelo servico 12.
// Mesmo ajuste que a home antiga fazia; a regra do mobile (filtro por branch) segue pendente.
const AUTOPECAS_SERVICE_ID = 12

async function loadServiceTypes() {
  const res = await getTopServices()
  const list = Array.isArray(res.payload) ? res.payload : []
  let branch = null
  try {
    const { data } = await services.api.get(services.config.endpoint + 'branches?description=Autopeças')
    branch = Array.isArray(data) && data[0] ? { ...data[0], id: AUTOPECAS_SERVICE_ID } : null
  } catch (err) {
    // Sem o ramo, o atalho de Autopecas usa o servico como veio da API.
  }
  return list
    .filter(item => item && item.Services && item.Services.description)
    .map(item => (branch && item.Services.description === branch.description ? { ...item, Services: branch } : item))
}

// "Lavagem/Polimento" quebra depois da barra, e nao no meio da palavra.
const breakAfterSlash = text => text.replace(/\//g, '/\u200b')

// Busca do hero: barra da cidade + categorias com icone. Tudo leva a lista de oficinas (/companies).
export default function HomeSearch({ history }) {
  const dispatch = useDispatch()
  const { selectedCity, filters } = useSelector(state => state.provider)
  const [serviceTypes, setServiceTypes] = useState([])
  const [cityModalOpen, setCityModalOpen] = useState(false)
  const [searchAfterCity, setSearchAfterCity] = useState(false)

  useEffect(() => {
    let active = true
    dispatch(clearFilters())
    loadServiceTypes().then(list => { if (active) setServiceTypes(list) })
    return () => { active = false }
  }, [dispatch])

  const hasCity = Boolean(selectedCity && selectedCity.id)
  const cityLabel = hasCity ? `${selectedCity.Name} - ${selectedCity.States.Initials}` : 'Onde você está?'

  const goToCompanies = () => {
    if (hasCity) {
      history.push('/companies')
      return
    }
    setSearchAfterCity(true)
    setCityModalOpen(true)
  }

  const handleSubmit = event => {
    event.preventDefault()
    goToCompanies()
  }

  const handleService = item => {
    const already = filters.services.some(service => String(service.id) === String(item.Services.id))
    if (!already) dispatch(addFilters(item.Services, 'services', filters))
    goToCompanies()
  }

  const showAll = () => {
    dispatch(handleChange(true, 'more'))
    goToCompanies()
  }

  const handleCity = city => {
    dispatch(handleChange(city, 'selectedCity'))
    setCityModalOpen(false)
    if (searchAfterCity) history.push('/companies')
  }

  return (
    <section className='home-search' aria-label='Buscar oficinas e autopeças'>
      <form className='home-search-bar' onSubmit={handleSubmit}>
        <button
          type='button'
          className='home-search-field'
          aria-label={`Cidade: ${cityLabel}`}
          onClick={() => { setSearchAfterCity(false); setCityModalOpen(true) }}
        >
          <FontAwesomeIcon icon={faMapMarkerAlt} aria-hidden='true' className='home-search-icon' />
          <span className='home-search-text'>
            <span className='home-search-label'>Oficinas e autopeças em</span>
            <span className={`home-search-value${hasCity ? '' : ' is-placeholder'}`}>{cityLabel}</span>
          </span>
        </button>
        <button type='submit' className='home-search-submit' aria-label='Encontrar oficinas'>
          <FontAwesomeIcon icon={faSearch} aria-hidden='true' />
          <span className='home-search-submit-text'>Encontrar oficinas</span>
        </button>
      </form>

      <p className='home-search-proof'>
        <FontAwesomeIcon icon={faShieldAlt} aria-hidden='true' />
        Seu histórico reunido, mesmo quando você troca de oficina parceira.
      </p>

      {serviceTypes.length > 0 && (
        <div className='home-search-categories'>
          <span className='home-search-categories-title'>O que você precisa?</span>
          <ul>
            {serviceTypes.map(item => (
              <li key={item.Services.id}>
                <button type='button' onClick={() => handleService(item)}>
                  <span className='home-search-category-icon' aria-hidden='true'>
                    <FontAwesomeIcon icon={item.icon || faWrench} />
                  </span>
                  {breakAfterSlash(item.Services.description)}
                </button>
              </li>
            ))}
            <li>
              <button type='button' onClick={showAll}>
                <span className='home-search-category-icon' aria-hidden='true'>
                  <FontAwesomeIcon icon={faEllipsisH} />
                </span>
                Ver todos
              </button>
            </li>
          </ul>
        </div>
      )}

      {cityModalOpen && (
        <SearchLocationModal
          show={cityModalOpen}
          onHide={() => setCityModalOpen(false)}
          onSelectCity={handleCity}
        />
      )}
    </section>
  )
}
